module.exports = __webpack_public_path__ + "media/img/features/preliminary-step-thumb-b9f479d45fec88c61cd348ace379495e.png";